import script from "./PermissionIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionIndex.vue?vue&type=script&setup=true&lang=js"

import "./PermissionIndex.vue?vue&type=style&index=0&id=fddb9726&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fddb9726"]])

export default __exports__